import CheckIcon from "../icons/CheckIcon";

const Functions = ({ selected, setSelected, locale }) => {
  return (
    <li
      onClick={() => setSelected(0)}
      className={`flex items-center justify-between xs:justify-start gap-2 p-1.5 border ${
        selected === 0 && "border-primary-900"
      } rounded-md cursor-pointer`}
    >
      <span className="flex flex-col items-center justify-center">
        <span className="flex items-center">
          <hr className="w-4 border border-green-600 xs:w-14" />
          <span className="grid border border-green-600 rounded-full size-5 place-items-center">
            <CheckIcon className="text-green-600 size-2" />
          </span>
        </span>
      </span>
      <span className="flex items-center justify-center flex-1 gap-1">
        {/* <TbCategory /> */}
        <span>{locale === "en" ? "Functions" : "الدوال"}</span>
      </span>
    </li>
  );
};

export default Functions;
